export const isBasicRoute = (pathname: string) => pathname.includes("basic")
export const isSubtasksRoute = (pathname: string) => pathname.includes("subtasks")
export const isKanbanRoute = (pathname: string) => pathname.includes("kanban")
export const isTodoListRoute = (pathname: string) => pathname.includes("todos")
export const isCalendarRoute = (pathname: string) => pathname.includes("calendar")
export const isReportedHoursRoute = (pathname: string) => pathname.includes("reported-hours")

export const taskTabsOrder = ["basic", "subtasks", "todos", "calendar", "kanban", "reported-hours", "chat"] as const

export type TaskTab = (typeof taskTabsOrder)[number]

export const getActiveTabIndex = (pathname: string, visibleTabs: readonly TaskTab[] = taskTabsOrder) => {
  const activeTab = taskTabsOrder.find((tab) => pathname.includes(tab))
  if (!activeTab) return 0

  const index = visibleTabs.indexOf(activeTab)
  if (index === -1) return false

  return index
}
